export default "__VITE_ASSET__BdqIYyBm__"